/**
 * Client-side unique id, safe outside a secure context.
 *
 * `crypto.randomUUID` exists only on https and localhost, so it is `undefined`
 * on a plain-http dev host (`http://192.168.x.x:5173`), in some embedded
 * webviews, and on an IP-address origin. Calling it bare there throws a
 * `TypeError`, which in an async path surfaces as an unhandled rejection rather
 * than anything actionable.
 *
 * The fallback is not cryptographically random and must not be used where that
 * matters — every caller here needs uniqueness within one tab, not secrecy.
 *
 * @param {string} [prefix] - Optional label, useful when the id appears in logs.
 * @returns {string} A unique id.
 */
export function createClientId(prefix?: string): string {
	const id =
		typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
			? crypto.randomUUID()
			: `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
	return prefix ? `${prefix}-${id}` : id
}
